import { MODES, pathFor, type Lang } from '../lib/routes';
import { useApp } from '../app-context';

// Visible, localized SEO content area (best-practice §5.3) with internal links.
// Core keyword "Animedle" is woven through every block for keyword density (§1).
export default function SeoContent({ lang }: { lang: Lang }) {
  const { t, navigate } = useApp();
  const enabled = MODES.filter((m) => m.enabled);

  const link = (mode: string, label: string) => (
    <a href={pathFor(lang, mode)} onClick={(e) => { e.preventDefault(); navigate(lang, mode); }}>{label}</a>
  );

  return (
    <section className="seo-content" aria-label="About Animedle">
      <div className="seo-block">
        <h2>{t('seo.about.h2')}</h2>
        <p>{t('seo.about.p')}</p>
      </div>

      <div className="seo-block">
        <h2>{t('seo.howto.h2')}</h2>
        <ol>
          <li>{t('seo.howto.1')}</li>
          <li>{t('seo.howto.2')}</li>
          <li>{t('seo.howto.3')}</li>
          <li>{t('seo.howto.4')}</li>
        </ol>
      </div>

      <div className="seo-block">
        <h2>{t('seo.modes.h2')}</h2>
        <p>{t('seo.modes.intro')}</p>
        <ul className="seo-modes">
          {enabled.map((m) => (
            <li key={m.key}>{link(m.key, t(`mode.${m.key}`))} — {t(`seo.modes.${m.key}`)}</li>
          ))}
        </ul>
      </div>

      <div className="seo-block">
        <h2>{t('seo.faq.h2')}</h2>
        {[1, 2, 3, 4].map((i) => (
          <div key={i}>
            <h3>{t(`seo.faq.q${i}`)}</h3>
            <p>
              {i === 3
                ? <>Animedle sources anime titles, studios, genres and cover art from <a href="https://anilist.co" target="_blank" rel="noopener noreferrer">AniList</a>.</>
                : t(`seo.faq.a${i}`)}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
